import React, { useRef } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

//svgs

import comp1 from '../assets/images/comp1.png';
import comp2 from '../assets/images/comp2.png';
import comp3 from '../assets/images/comp3.png';

//animations
import {Layer1Variants, Layer2Variants, Layer3Variants} from '../animations/MainPageAnims';

function Homesvg() {

    const layer1 = useRef();
    const layer2 = useRef();
    const layer3 = useRef();

    useEffect(() => {//under use effect so that this function runs only once the dom has been rendered.

        window.addEventListener('mousemove', (e) => {

            let x1 = (window.innerWidth - e.pageX) / 100;//the less we divide the more they move
            let y1 = (window.innerHeight - e.pageY) / 70;

            let x2 = (window.innerWidth - e.pageX) / 80;
            let y2 = (window.innerHeight - e.pageY) / 50;

            let x3 = (window.innerWidth - e.pageX) / 40;
            let y3 = (window.innerHeight - e.pageY) / 20;


            if (layer1.current) { //to avoid null values
                layer1.current.style.transform = `translateX(${x1}px) translateY(${y1}px)`;
                layer2.current.style.transform = `translateX(${x2}px) translateY(${y2}px)`;
                layer3.current.style.transform = `translateX(${x3}px) translateY(${y3}px)`;
            }

        });

    }, []);


    return (
        <SvgCont className='home-svg-container' >
            <div className="wrapper">
                <motion.div
                    variants={Layer3Variants}
                    initial='initial'
                    animate='animate'
                    exit='exit'
                    className="layer-3 parallax" ref={layer3} >
                    <img className='comp3' src={comp3} alt="" />
                </motion.div>
                <motion.div
                    variants={Layer1Variants}
                    initial='initial'
                    animate='animate'
                    exit='exit'
                    className="layer-1 parallax" ref={layer1} >
                    <img className='comp1' src={comp1} alt="" />
                </motion.div>
                <motion.div
                    variants={Layer2Variants}
                    initial='initial'
                    animate='animate'
                    exit='exit'
                    className="layer-2 parallax" ref={layer2} >
                    <img className='comp2' src={comp2} alt="" />
                </motion.div>
            </div>
        </SvgCont>
    );
}

const SvgCont = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100vh;

    .wrapper{
        position: absolute;
        right: 10%;
        top: 50%;
        transform: translateY(-50%);
        /* border: 2px solid red; */
        width: 40%; 
    }

    //saperate
    .comp1, .comp2, .comp3{
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }

    .comp2{
        opacity: 0.7;
    }

    @media only screen and (max-width: 500px){
        .wrapper{
            top: 28%;
            width: 70%;
            right: 50%;
            transform: translateX(50%);
        }
    }

`

export default Homesvg;